export default {"src":"https://images-cdn-staging.curipod.com/d-bd7b79d2/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};